import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import {
  Section,
  Container,
  Button,
  Overlay,
  SanityBlockContent,
} from '../../common';
import { getMaxWidthClass } from '../../../utils';

// const StyledHeadline = styled.h2`
//   color: #fff !important;
//   &:hover {
//     color: #ggg !important;
//   }
// `;

const StyledLink = styled((props) => <Link {...props} />)`
  color: ${(props) => props.$color} !important;
  &:hover {
    color: ${(props) => props.$colorHover} !important;
  }
`;

const CtaFull = ({ sanity, page, section }) => {
  const { colors } = sanity;
  const maxWidthClassHeadline = getMaxWidthClass(section?.header?.headline);
  const maxWidthClassDescription = getMaxWidthClass(
    section?.header?._rawDescription
  );

  const variants = {
    hidden: { opacity: 0, scale: 0.8, x: -100 },
    visible: { opacity: 1, scale: 1, x: 0 },
  };

  const controls = useAnimation();
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
    if (!inView) {
      controls.start('hidden');
    }
  }, [controls, inView]);

  return (
    <Section idName="cta-full" padding="none" h2Color={colors?.accent?.lighter}>
      <Container padding="none">
        <Container
          disableAnimations={true}
          padding="none"
          classes="absolute inset-0"
        >
          <GatsbyImage
            image={section?.image?.asset?.gatsbyImageData}
            alt={section?.image?.alt}
            className="h-full w-full object-cover object-center"
            loading="lazy"
          />
          <Overlay
            isGradient={true}
            bgColor={colors?.neutral?.default}
            bgColorHover={colors?.neutral?.dark}
            bgColorStart={colors?.neutral?.darker}
            bgColorMid={colors?.neutral?.dark}
            bgColorEnd={colors?.neutral?.default}
          />
        </Container>
        <div className="relative mx-auto max-w-4xl px-4 py-16 text-center sm:py-20 lg:px-0">
          <motion.h2
            ref={ref}
            variants={variants}
            initial="hidden"
            animate={controls}
            transition={{ duration: 0.5, delay: 0 }}
            className={`${maxWidthClassHeadline} drop-shadow-darker mx-auto text-4xl font-extrabold capitalize tracking-tight !text-white sm:text-5xl lg:text-6xl`}
          >
            {section?.header?.headline}
          </motion.h2>
          <motion.div
            ref={ref}
            variants={variants}
            initial="hidden"
            animate={controls}
            transition={{ duration: 0.5, delay: 0.2 }}
            className={`${maxWidthClassDescription} drop-shadow-darker mx-auto mt-12 max-w-2xl text-2xl font-light text-white lg:text-3xl`}
          >
            <SanityBlockContent
              sanity={sanity}
              blocks={section?.header?._rawDescription}
            />
          </motion.div>
          <motion.div
            ref={ref}
            variants={variants}
            initial="hidden"
            animate={controls}
            transition={{
              duration: 0.5,
              delay: 0.6,
            }}
            className="mt-10 flex"
          >
            <div className="col-1 mx-auto gap-4">
              <Button
                linkType="internal"
                internalLink={section?.ctaButtonLink?.slug?.current}
                label={section?.ctaButtonLabel}
                page={page}
                sanity={sanity}
              />
            </div>
          </motion.div>
        </div>
      </Container>
    </Section>
  );
};

export { CtaFull };
